import {
  rankingArticles,
  rankingProducts,
  rankingCategories,
} from "@/mocks/homeData";

export default function RankingSection() {
  return (
    <div>
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div className="flex items-center gap-2">
          <i className="ri-fire-line text-accent-500 text-lg"></i>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950">
            人気ランキング
          </h2>
        </div>
        <a
          href="#"
          className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1"
        >
          もっと見る
          <i className="ri-arrow-right-s-line"></i>
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {/* Article Ranking */}
        <div className="bg-white rounded-xl border border-background-200 p-4 md:p-5">
          <h3 className="text-sm font-bold text-foreground-800 mb-4 pb-2 border-b border-background-100">
            人気記事ランキング
          </h3>
          <div className="space-y-3">
            {rankingArticles.map((article) => (
              <a
                key={article.rank}
                href="#"
                className="flex items-start gap-3 group"
              >
                <span
                  className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold shrink-0 ${
                    article.rank === 1
                      ? "bg-accent-500 text-white"
                      : article.rank === 2
                        ? "bg-secondary-400 text-white"
                        : "bg-background-300 text-foreground-700"
                  }`}
                >
                  {article.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {article.title}
                  </p>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {article.views}
                  </p>
                </div>
              </a>
            ))}
          </div>
          <div className="mt-4 text-center">
            <a
              href="#"
              className="inline-flex items-center text-xs text-foreground-500 hover:text-primary-500 transition-colors border border-background-200 rounded-full px-4 py-1.5"
            >
              もっと見る
              <i className="ri-arrow-right-s-line ml-1"></i>
            </a>
          </div>
        </div>

        {/* Product Ranking */}
        <div className="bg-white rounded-xl border border-background-200 p-4 md:p-5">
          <h3 className="text-sm font-bold text-foreground-800 mb-4 pb-2 border-b border-background-100">
            人気商品ランキング
          </h3>
          <div className="space-y-4">
            {rankingProducts.map((product) => (
              <a
                key={product.rank}
                href="#"
                className="flex items-center gap-3 group"
              >
                <div className="relative shrink-0">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden bg-background-100">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span
                    className={`absolute -top-1.5 -left-1.5 w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-bold ${
                      product.rank === 1
                        ? "bg-accent-500 text-white"
                        : product.rank === 2
                          ? "bg-secondary-400 text-white"
                          : "bg-background-300 text-foreground-700"
                    }`}
                  >
                    {product.rank}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {product.name}
                  </p>
                  <p className="text-sm font-bold text-accent-500 mt-1">
                    {product.price}
                  </p>
                </div>
              </a>
            ))}
          </div>
          <div className="mt-4 text-center">
            <a
              href="#"
              className="inline-flex items-center text-xs text-foreground-500 hover:text-primary-500 transition-colors border border-background-200 rounded-full px-4 py-1.5"
            >
              もっと見る
              <i className="ri-arrow-right-s-line ml-1"></i>
            </a>
          </div>
        </div>

        {/* Category Ranking */}
        <div className="bg-white rounded-xl border border-background-200 p-4 md:p-5">
          <h3 className="text-sm font-bold text-foreground-800 mb-4 pb-2 border-b border-background-100">
            人気カテゴリランキング
          </h3>
          <div className="space-y-3">
            {rankingCategories.map((cat) => (
              <a
                key={cat.rank}
                href="#"
                className="flex items-center gap-3 group"
              >
                <span
                  className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold shrink-0 ${
                    cat.rank === 1
                      ? "bg-accent-500 text-white"
                      : cat.rank === 2
                        ? "bg-secondary-400 text-white"
                        : "bg-background-300 text-foreground-700"
                  }`}
                >
                  {cat.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </p>
                </div>
                <span className="text-xs text-foreground-500">
                  {cat.count}件
                </span>
              </a>
            ))}
          </div>
          <div className="mt-4 text-center">
            <a
              href="#"
              className="inline-flex items-center text-xs text-foreground-500 hover:text-primary-500 transition-colors border border-background-200 rounded-full px-4 py-1.5"
            >
              もっと見る
              <i className="ri-arrow-right-s-line ml-1"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}